<template>
	<div class="detail-view bed">
		<bed-page></bed-page>
	</div>
</template>

<script>
import BedPage from "../components/pages/BedPage";
export default {
  name: "Bed",
  components: {BedPage},
}
</script>

